/**
 * PreviewFaq — Accordion FAQ section
 */

interface FaqItem {
  question: string;
  answer: string;
}

interface PreviewFaqProps {
  data: {
    title?: string;
    subtitle?: string;
    items?: FaqItem[];
  };
  settings: {
    [key: string]: any;
  };
}

export function PreviewFaq({ data, settings }: PreviewFaqProps) {
  return (
    <section className="preview-faq" id="faq">
      <div className="preview-container">
        <div className="preview-section-header">
          <h2>{data.title}</h2>
          <p>{data.subtitle}</p>
        </div>

        <div className="preview-faq__list">
          {data.items?.map((item, i) => (
            <details key={i} className="preview-faq-item">
              <summary>{item.question}</summary>
              <div className="preview-faq-item__answer">
                {item.answer}
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
